import { render, staticRenderFns } from "./index-emptyShop.vue?vue&type=template&id=35b4f724&scoped=true"
import script from "./index-emptyShop.vue?vue&type=script&lang=js"
export * from "./index-emptyShop.vue?vue&type=script&lang=js"
import style0 from "./index-emptyShop.vue?vue&type=style&index=0&id=35b4f724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b4f724",
  null
  
)

export default component.exports